import { api } from "~/utils/api";
import { display } from "~/components/ui/sonner";

export const useConversationUpsert = () => {
  const utils = api.useUtils();
  return api.communication.upsertConversation.useMutation({
    onError: () => {
      display.error("Failed to start conversation");
    },
    onSettled: (_d, _e, props) => {
      if ("bidIds" in props && props.bidIds) {
        props.bidIds.forEach((bidId) => {
          void utils.communication.getConversationsByBidId.invalidate({ bidId });
          void utils.communication.getRelatedHomeownerConversationsByBidId.invalidate({ bidId });
        });
      }
    },
  });
};
